module.exports = __webpack_public_path__ + "static/media/Shaadibazar_Logo_Sample_01.80d324d6.jpg";